<template>
  <div class="register">
    <!-- 背景装饰 -->
    <div class="register-bg">
      <div class="bg-shape shape-1"></div>
      <div class="bg-shape shape-2"></div>
      <div class="bg-shape shape-3"></div>
      <div class="bg-shape shape-4"></div>
    </div>

    <!-- 中间主体 -->
    <div class="wrapper">
      <div class="container">
        <!-- 表单容器 -->
        <div class="register-form">
          <!-- 头部 -->
          <div class="form-header">
            <div class="logo-section">
              <div class="logo-icon">🚀</div>
              <div class="logo-text">
                <h2>创建账号</h2>
                <p>Join Our Community</p>
              </div>
            </div>
            <div class="header-decoration">
              <div class="decoration-line"></div>
              <div class="decoration-dot"></div>
              <div class="decoration-line"></div>
            </div>
          </div>

          <!-- 表单主体 -->
          <div class="form-body">
            <!-- 账号输入 -->
            <div class="input-group">
              <div class="input-container">
                <i class="iconfont icon-denglu2 input-icon"></i>
                <input type="text" placeholder="请输入账号" v-model="rUsername" class="form-input" />
                <div class="input-focus-line"></div>
              </div>
              <div class="input-tips" v-if="rUsername">
                <span class="tip-item" :class="{ 'valid': rUsername.length >= 4 }">
                  ✓ 至少4位字符
                </span>
              </div>
            </div>

            <!-- 密码输入 -->
            <div class="input-group">
              <div class="input-container">
                <i class="iconfont icon-mima input-icon"></i>
                <input type="password" placeholder="请输入密码" v-model="rPassword" class="form-input" />
                <div class="input-focus-line"></div>
                <div class="password-strength" v-if="rPassword">
                  <div class="strength-bar" :class="getPasswordStrength"></div>
                </div>
              </div>
              <div class="input-tips" v-if="rPassword">
                <span class="tip-item" :class="{ 'valid': rPassword.length >= 6 }">
                  ✓ 至少6位字符
                </span>
                <span class="tip-item" :class="{ 'valid': /[A-Z]/.test(rPassword) }">
                  ✓ 包含大写字母
                </span>
                <span class="tip-item" :class="{ 'valid': /[0-9]/.test(rPassword) }">
                  ✓ 包含数字
                </span>
              </div>
            </div>

            <!-- 用户协议 -->
            <div class="agreement-group">
              <label class="agreement-check">
                <input type="checkbox" v-model="agreed" class="checkbox-input" />
                <span class="checkmark"></span>
                <span class="agreement-text">
                  我已阅读并同意
                  <a href="/#/xy" class="agreement-link">《用户协议》</a>

                  和
                  <a href="/#/ac4" class="agreement-link">《隐私政策》</a>
                </span>
              </label>
            </div>

            <!-- 注册按钮 -->
            <div class="btn-group">
              <button class="register-btn" @click="register()" :disabled="!agreed">
                <span class="btn-text">立即注册</span>
                <div class="btn-icon">🎉</div>
                <div class="btn-shine"></div>
                <div class="btn-particles"></div>
              </button>
            </div>

            <!-- 底部提示 -->
            <div class="form-footer">
              <div class="tips">
                <span class="tip-text">已有账号？</span>
                <span class="login-link" @click="goLogin()">立即登录</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "register",
  components: {},
  data() {
    return {
      href: "index.html",
      rUsername: "",
      rPassword: "",
      agreed: false,
      logo_user: JSON.parse(window.localStorage.getItem("user")),
    };
  },
  computed: {
    getPasswordStrength() {
      if (!this.rPassword) return 'empty';
      let strength = 0;
      if (this.rPassword.length >= 6) strength++;
      if (/[A-Z]/.test(this.rPassword)) strength++;
      if (/[0-9]/.test(this.rPassword)) strength++;
      if (/[^A-Za-z0-9]/.test(this.rPassword)) strength++;

      return ['weak', 'medium', 'good', 'strong'][strength - 1] || 'empty';
    }
  },
  mounted() {
    document.title = "京游科技（北京）有限公司";
  },
  methods: {
    // 注册逻辑
    register() {
      // 获取 user
      var ruser = {
        Username: this.rUsername,
        Password: this.rPassword,
      };
      // 判断非空
      if (!this.rUsername) {
        alert("请输入用户名");
        return;
      }
      if (!this.rPassword) {
        alert("请输入密码");
        return;
      }
      if (!this.agreed) {
        alert("请同意用户协议");
        return;
      }
      window.localStorage.setItem("state", "0");
      window.localStorage.setItem("user", JSON.stringify(ruser));
      this.$router.push("/#/index");
      window.location.reload();
    },
    goLogin() {
      this.$router.push("/login");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";
@import "./../assets/scss/button.scss";
@import "./../assets/font/iconfont.css";

.register {
  min-height: 100vh;
  background: linear-gradient(135deg, #764ba2 0%, #667eea 100%);
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  // 背景装饰
  .register-bg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;

    .bg-shape {
      position: absolute;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.1);
      animation: float 6s ease-in-out infinite;

      &.shape-1 {
        width: 300px;
        height: 300px;
        top: -150px;
        right: -150px;
        animation-delay: 0s;
      }

      &.shape-2 {
        width: 200px;
        height: 200px;
        bottom: -100px;
        left: -100px;
        animation-delay: 2s;
        animation-direction: reverse;
      }

      &.shape-3 {
        width: 150px;
        height: 150px;
        top: 20%;
        right: 10%;
        animation-delay: 1s;
      }

      &.shape-4 {
        width: 120px;
        height: 120px;
        bottom: 30%;
        left: 10%;
        animation-delay: 3s;
        animation-direction: reverse;
      }
    }
  }

  .wrapper {
    position: relative;
    z-index: 2;
    width: 100%;

    .container {
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: 100vh;
      padding: 40px 20px;

      // 表单容器
      .register-form {
        width: 480px;
        background: rgba(255, 255, 255, 0.95);
        backdrop-filter: blur(20px);
        border-radius: 24px;
        padding: 50px 40px;
        box-shadow:
          0 20px 60px rgba(0, 0, 0, 0.15),
          0 0 0 1px rgba(255, 255, 255, 0.1);
        border: 1px solid rgba(255, 255, 255, 0.2);
        animation: formSlideUp 0.8s cubic-bezier(0.4, 0, 0.2, 1);

        // 头部
        .form-header {
          text-align: center;
          margin-bottom: 40px;

          .logo-section {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 16px;
            margin-bottom: 20px;

            .logo-icon {
              font-size: 48px;
              background: linear-gradient(135deg, #52c41a, #1890ff);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1));
            }

            .logo-text {
              text-align: left;

              h2 {
                font-size: 28px;
                font-weight: 700;
                color: #1a1a1a;
                margin: 0 0 4px 0;
                line-height: 1.2;
              }

              p {
                font-size: 14px;
                color: #666;
                margin: 0;
                font-weight: 500;
              }
            }
          }

          .header-decoration {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 12px;

            .decoration-line {
              width: 40px;
              height: 2px;
              background: linear-gradient(90deg, #52c41a, #1890ff);
              border-radius: 1px;
            }

            .decoration-dot {
              width: 6px;
              height: 6px;
              background: #52c41a;
              border-radius: 50%;
              animation: pulse 2s infinite;
            }
          }
        }

        // 表单主体
        .form-body {
          .input-group {
            margin-bottom: 24px;

            .input-container {
              position: relative;

              .input-icon {
                position: absolute;
                left: 16px;
                top: 50%;
                transform: translateY(-50%);
                font-size: 20px;
                color: #666;
                z-index: 2;
                transition: all 0.3s ease;
              }

              .form-input {
                width: 100%;
                height: 56px;
                padding: 0 20px 0 52px;
                border: 2px solid #f0f0f0;
                border-radius: 12px;
                font-size: 16px;
                background: #fff;
                transition: all 0.3s ease;
                outline: none;
                box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);

                &:focus {
                  border-color: #52c41a;
                  box-shadow: 0 4px 16px rgba(82, 196, 26, 0.15);

                  &+.input-focus-line {
                    width: 100%;
                  }

                  &~.input-icon {
                    color: #52c41a;
                    transform: translateY(-50%) scale(1.1);
                  }
                }

                &::placeholder {
                  color: #999;
                }
              }

              .input-focus-line {
                position: absolute;
                bottom: 0;
                left: 50%;
                transform: translateX(-50%);
                width: 0;
                height: 2px;
                background: linear-gradient(90deg, #52c41a, #1890ff);
                transition: width 0.3s ease;
                border-radius: 1px;
              }

              .password-strength {
                position: absolute;
                bottom: -6px;
                left: 0;
                right: 0;
                height: 3px;
                background: #f0f0f0;
                border-radius: 2px;
                overflow: hidden;

                .strength-bar {
                  height: 100%;
                  width: 0%;
                  transition: all 0.3s ease;
                  border-radius: 2px;

                  &.empty {
                    width: 0%;
                    background: transparent;
                  }

                  &.weak {
                    width: 25%;
                    background: #ff4d4f;
                  }

                  &.medium {
                    width: 50%;
                    background: #faad14;
                  }

                  &.good {
                    width: 75%;
                    background: #1890ff;
                  }

                  &.strong {
                    width: 100%;
                    background: #52c41a;
                  }
                }
              }
            }

            .input-tips {
              display: flex;
              flex-wrap: wrap;
              gap: 12px;
              margin-top: 12px;

              .tip-item {
                font-size: 12px;
                color: #999;
                transition: all 0.3s ease;

                &.valid {
                  color: #52c41a;
                  font-weight: 500;
                }
              }
            }
          }

          // 用户协议
          .agreement-group {
            margin: 24px 0;

            .agreement-check {
              display: flex;
              align-items: flex-start;
              gap: 12px;
              cursor: pointer;
              position: relative;

              .checkbox-input {
                position: absolute;
                opacity: 0;
                cursor: pointer;

                &:checked+.checkmark {
                  background: linear-gradient(135deg, #52c41a, #1890ff);
                  border-color: transparent;

                  &::after {
                    display: block;
                  }
                }
              }

              .checkmark {
                position: relative;
                height: 20px;
                width: 20px;
                background: #fff;
                border: 2px solid #ddd;
                border-radius: 6px;
                transition: all 0.3s ease;
                flex-shrink: 0;
                margin-top: 2px;

                &::after {
                  content: '✓';
                  position: absolute;
                  top: 50%;
                  left: 50%;
                  transform: translate(-50%, -50%);
                  color: #fff;
                  font-size: 12px;
                  font-weight: bold;
                  display: none;
                }
              }

              .agreement-text {
                font-size: 14px;
                color: #666;
                line-height: 1.5;

                .agreement-link {
                  color: #1890ff;
                  text-decoration: none;
                  font-weight: 500;
                  transition: color 0.3s ease;

                  &:hover {
                    color: #52c41a;
                    text-decoration: underline;
                  }
                }
              }

              &:hover .checkmark {
                border-color: #52c41a;
              }
            }
          }

          // 注册按钮
          .btn-group {
            margin: 32px 0 24px;

            .register-btn {
              width: 100%;
              height: 56px;
              background: linear-gradient(135deg, #52c41a, #1890ff);
              border: none;
              border-radius: 12px;
              color: #fff;
              font-size: 16px;
              font-weight: 600;
              cursor: pointer;
              position: relative;
              overflow: hidden;
              transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
              display: flex;
              align-items: center;
              justify-content: center;
              gap: 8px;

              &:hover:not(:disabled) {
                transform: translateY(-2px);
                box-shadow:
                  0 12px 30px rgba(82, 196, 26, 0.4),
                  0 4px 12px rgba(24, 144, 255, 0.3);

                .btn-icon {
                  transform: scale(1.2) rotate(10deg);
                }

                .btn-shine {
                  transform: translateX(100%);
                }

                .btn-particles {
                  opacity: 1;

                  &::before,
                  &::after {
                    animation: particles 0.6s ease-out forwards;
                  }
                }
              }

              &:active:not(:disabled) {
                transform: translateY(0);
              }

              &:disabled {
                background: #ccc;
                cursor: not-allowed;
                transform: none;
                box-shadow: none;
              }

              .btn-text {
                position: relative;
                z-index: 2;
              }

              .btn-icon {
                font-size: 18px;
                transition: transform 0.3s ease;
                position: relative;
                z-index: 2;
              }

              .btn-shine {
                position: absolute;
                top: 0;
                left: -100%;
                width: 100%;
                height: 100%;
                background: linear-gradient(90deg,
                    transparent,
                    rgba(255, 255, 255, 0.3),
                    transparent);
                transition: transform 0.6s ease;
              }

              .btn-particles {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                opacity: 0;
                transition: opacity 0.3s ease;

                &::before,
                &::after {
                  content: '✨';
                  position: absolute;
                  font-size: 16px;
                  opacity: 0;
                }

                &::before {
                  top: 10px;
                  left: 20px;
                  animation-delay: 0.1s;
                }

                &::after {
                  top: 10px;
                  right: 20px;
                  animation-delay: 0.2s;
                }
              }
            }
          }

          // 底部提示
          .form-footer {
            text-align: center;

            .tips {
              display: flex;
              align-items: center;
              justify-content: center;
              gap: 8px;

              .tip-text {
                font-size: 14px;
                color: #666;
              }

              .login-link {
                font-size: 14px;
                color: #1890ff;
                font-weight: 600;
                cursor: pointer;
                position: relative;
                transition: all 0.3s ease;

                &:hover {
                  color: #52c41a;

                  &::after {
                    width: 100%;
                  }
                }

                &::after {
                  content: '';
                  position: absolute;
                  bottom: -2px;
                  left: 0;
                  width: 0;
                  height: 2px;
                  background: linear-gradient(90deg, #1890ff, #52c41a);
                  transition: width 0.3s ease;
                  border-radius: 1px;
                }
              }
            }
          }
        }
      }
    }
  }
}

// 动画定义
@keyframes float {

  0%,
  100% {
    transform: translateY(0) rotate(0deg);
  }

  50% {
    transform: translateY(-20px) rotate(180deg);
  }
}

@keyframes formSlideUp {
  from {
    opacity: 0;
    transform: translateY(40px) scale(0.95);
  }

  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@keyframes pulse {

  0%,
  100% {
    opacity: 0.7;
    transform: scale(1);
  }

  50% {
    opacity: 1;
    transform: scale(1.2);
    box-shadow: 0 0 10px #52c41a;
  }
}

@keyframes particles {
  0% {
    opacity: 0;
    transform: translateY(0) scale(0);
  }

  50% {
    opacity: 1;
    transform: translateY(-20px) scale(1);
  }

  100% {
    opacity: 0;
    transform: translateY(-40px) scale(0);
  }
}

// 响应式调整
@media (max-width: 480px) {
  .register-form {
    width: 90% !important;
    padding: 40px 24px !important;
  }
}
</style>